/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TextbookType = "CORE_TEXTBOOK" | "LEGACY" | "SKILLS_BOOK";
export type FreeTextbooksSubtopicViewQueryVariables = {
    syllabusId: string;
};
export type FreeTextbooksSubtopicViewQueryResponse = {
    readonly syllabus: {
        readonly textbookType: TextbookType;
    } | null;
};
export type FreeTextbooksSubtopicViewQuery = {
    readonly response: FreeTextbooksSubtopicViewQueryResponse;
    readonly variables: FreeTextbooksSubtopicViewQueryVariables;
};



/*
query FreeTextbooksSubtopicViewQuery(
  $syllabusId: ID!
) {
  syllabus(id: $syllabusId) {
    textbookType
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "syllabusId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "syllabusId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textbookType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreeTextbooksSubtopicViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookSyllabus",
        "kind": "LinkedField",
        "name": "syllabus",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreeTextbooksSubtopicViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookSyllabus",
        "kind": "LinkedField",
        "name": "syllabus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a7a566b32718b96ad50b1300e273ac70",
    "id": null,
    "metadata": {},
    "name": "FreeTextbooksSubtopicViewQuery",
    "operationKind": "query",
    "text": "query FreeTextbooksSubtopicViewQuery(\n  $syllabusId: ID!\n) {\n  syllabus(id: $syllabusId) {\n    textbookType\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '779944417989f389052c393493e6ee96';
export default node;
